import Vue from 'vue'
import LoadingComponent from '@/components/loading/index.vue'

// 使用 Vue.extends 构造组件子类
// 构造函数
const LoadingContructor = Vue.extend(LoadingComponent)

// 定义构造函数
export default {
  /** 钩子函数 **/
  /**
   * 只调用一次, 指令第一次绑定到元素时调用, 可进行`一次性的初始化设置`
   * @param {*} el 指令所绑定的元素, 可以直接操作DOM
   * @param {*} binding 指令传入的信息, 包括 {name: '指令名', value: '指令绑定的值', arg: 'v-directive:foo 参数为 "foo"'}
   */
  bind(el, binding) {
    // const vm = vnode.context;

    // 创建实例
    const instance = new LoadingContructor({
      el: document.createElement('div'),
    })

    const { position } = window.getComputedStyle(el)
    // 未设置定位方式则默认赋值 relative
    if (position === 'static' || !position) {
      el.style.position = 'relative'
    }
    // 挂载DOM
    el.appendChild(instance.$el)
    el.instance = instance

    // 挂载后显示
    Vue.nextTick(() => {
      // 获取传入的值
      el.instance.visible = binding.value
    })
  },
  /**
   * 所在组件VNode 更新时调用
   */
  update(el, binding) {
    const textExr = el.getAttribute('text') || ''
    let { oldValue, value } = binding
    // 判断loading是否显示
    if (oldValue !== value) {
      el.instance.visible = value
      el.instance.text = textExr
    }
  },
  /**
   * 只调用一次, 指令和元素解绑时调用
   */
  unbind(el) {
    let mask = el.instance.$el
    el.removeChild(mask)
    el.instance.$destroy()
    el.instance = undefined
  },
}
